define('constants/audioTypeEnumerations',[], function() {
    return {
        original: "original",
        callMedia: "callmedia",
        mp3: "mp3",
        ogg: "ogg"
    };
});
